import {VehicleForm as VFKit} from '../VehicleForm';

export function OwnershipGroup() {
  return (
    <>
      <VFKit.SimpleNumericField name="ownerCount" />
      <VFKit.SimpleNumericField name="primaryKeyCount" />
    </>
  );
}
